module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"upload":"Upload","preview":"Preview"},"zh":{"upload":"点击上传","preview":"预览"},"zh-TW":{"upload":"點擊上傳","preview":"預覽"},"th":{"upload":"อัปโหลด","preview":"แสดงตัวอย่าง"},"ko":{"upload":"업로드","preview":"미리보기"}}')
  delete Component.options._Ctor
}
